import { gql } from '@apollo/client';
import type { Association, AssociationConfig } from '@cobliteam/common-types';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import graphQLRequester from '../../request/GraphQLRequester';
import type { AssociationAPI } from './definitions';

export class GraphQLCameraAssociationRequester {
  private queryGetCameraAssociation = gql`
    query {
      association {
        association_config {
          entire_fleet_association_config {
            is_on
          }
        }
        fleet_id
        updated_at
        last_updated_by
      }
    }
  `;

  private mutationUpdateCameraAssociationRequest = gql`
    mutation ($input: AssociationConfigInput!) {
      updateAssociation(input: $input)
    }
  `;

  public getCameraAssociation = (): Promise<Association> =>
    graphQLRequester
      .query<{ association: AssociationAPI; errors: Array<any> }>({
        query: this.queryGetCameraAssociation,
      })
      .then((result) => {
        return camelcaseKeys(result?.association, {
          deep: true,
        });
      });

  public updateCameraAssociation = (input: AssociationConfig): Promise<boolean> =>
    graphQLRequester
      .mutate<{ updateAssociation: boolean }>({
        mutation: this.mutationUpdateCameraAssociationRequest,
        variables: {
          input: snakecaseKeys(input, { deep: true }),
        },
      })
      .then((result) => {
        return result.updateAssociation;
      });
}
